import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './style.scss';

export default class PageNotFound extends Component {
    render() {
        return (
            <div className="error_page">
                <div className="container">
                    <div className="row">
                        <h2>404</h2>
                        <h3  className="error-text">error</h3>
                        <img src="/images/404.svg" alt='404-error-page-not-found'/>
                        <p>
                            page not found
                        </p>
                        <span>instead, go to</span>
                        <Link to="/" className="btn-primary">HOME</Link>
                    </div>
                </div>
            </div>
        );
    }
}